import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Yalnızca yetkilendirilmiş ve admin olan kullanıcıların erişebileceği sayfalar için koruma
const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { currentUser, isAdmin, loading } = useAuth();

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  // Kullanıcı giriş yapmamışsa login sayfasına yönlendir
  if (!currentUser) {
    return <Navigate to="/auth/login" />;
  }

  // Kullanıcı giriş yapmış ama admin değilse ana sayfaya yönlendir
  if (adminOnly && !isAdmin) {
    return <Navigate to="/profile" />;
  }

  // Kullanıcı giriş yapmış ve admin ise içeriği göster
  return children;
};

export default ProtectedRoute; 